import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

const borderColor = "#93a9bd57";

export const CommentBody = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
}));

export const CommentType = styled("span")(() => ({
  textTransform: "capitalize",
}));

export const CommentCreatedAt = styled("span")(() => ({
  font: "600 12px/16px Manrope",
  color: colors.gray500,
  letterSpacing: 0.5,
}));

export const CommentMessage = styled("span")(() => ({
  font: "500 16px/24px Manrope",
  color: colors.gray600,
  overflowWrap: "anywhere",
  wordBreak: "break-word",
}));

interface CreatedAtTextProps {
  mobileStyled?: boolean;
}
export const CreatedAtText = styled("span")(({ mobileStyled = false }: CreatedAtTextProps) => ({
  display: mobileStyled ? "none" : "inline",
  "@media screen and (max-width: 475px)": {
    display: mobileStyled ? "inline" : "none",
  },
}));

export const CreatedOnText = styled("span")(() => ({
  "@media screen and (max-width: 475px)": {
    display: "none",
  },
}));

export const CommentContainerItem = styled(Grid)(() => ({
  border: `1px solid ${borderColor}`,
  borderRadius: 8,
  padding: 22,
  backgroundColor: colors.white,

  "@media screen and (max-width: 905px)": {
    padding: 16,
  },

  "@media screen and (max-width: 320px)": {
    padding: 8,
  },
}));

export const CommentContainer = styled(Grid)(() => ({
  margin: 0,
  gap: 16,
}));

export const DeleteModalIconContainer = styled("div")(() => ({
  backgroundColor: "#FEE4E2",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "100px",
  height: "32px",
  width: "32px",
  cursor: "pointer",

  "@media screen and (max-width: 875px)": {
    backgroundColor: "transparent",
    height: "fit-content",
    width: "fit-content",
  },
}));

export const CommmentHeaderContainer = styled(Grid)(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
}));

export const CommentHeaderUserWrapper = styled("div")(() => ({
  display: "flex",
  alignContent: "center",
  gap: "16px",
}));

export const CommentHeaderUserInfosWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 4,
}));

export const CommentUserName = styled("span")(() => ({
  font: "600 16px/24px Manrope",
  color: colors.gray600,
}));

export const CommentUserAvatarIcon = styled("div")(() => ({
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  position: "relative",
  cursor: "pointer",
}));

export const CommentUserIconImage = styled("img")(() => ({
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  position: "absolute",
  transform: "translate(-50%, -50%)",
  top: "50%",
  left: "50%",
  bottom: 0,
  right: 0,
}));
